import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postChangePassword = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/change-password`, params);
};

export {
    postChangePassword
}